import { combineReducers } from 'redux';
import {
    reducerMenus as menus,
    reducerNavigation as nav,
    reducerLogin as login,
    reduceReminders as reminder,
    reducerLiveCalls as liveCalls,
    reducerPbx as pbx
}from "./reducer";

export default combineReducers({
    menus,
    nav,
    login,
    reminder,
    liveCalls,
    pbx
})
